import React, { useState } from "react";
import {
  getDataFromConfig,
  removeValidationItemDataPoint,
  getIdToNameMappingOfDataPointsFromKPIID,
} from "../../../../../../../features/salescodeStudio/mandatoryConfigs/manageKPIReview/manageKpiReviewServices";
import DataPointInput from "../DataPointInput/DataPointInput";
import "../configureKPICommon.css";

interface KPIConfigDataPointLabelChangeProps {
  kpi: Record<string, any>;
  updateUserConfig: (_id: string, _kpi: Record<string, any>) => void;
  inputDataValidation: { minLength: number; maxLength: number };
  defaultConfigGlobal : Record<string,any>;
}

const KPIConfigDataPointLabelChange: React.FC<
  KPIConfigDataPointLabelChangeProps
> = ({ kpi, updateUserConfig,inputDataValidation ,defaultConfigGlobal }) => {
  const sortAccordingToOrder = (datapoints: Record<string, any>[]) => {
    return (
      datapoints?.sort(
        (a: Record<string, any>, b: Record<string, any>) =>
          Number(a.order || 0) - Number(b.order || 0)
      ) || []
    );
  };
  const userDataPoints: Record<string, any>[] = sortAccordingToOrder(
    removeValidationItemDataPoint(kpi.data_points)
  );

  const defaultConfigDataPoints = removeValidationItemDataPoint(
    getDataFromConfig("KPI_data_points", kpi.id,defaultConfigGlobal)
  );
  const [showAll, setShowAll] = useState<boolean>(
    userDataPoints.length === defaultConfigDataPoints.length
  );
  const handelOnClick = (): void => {
    const uniqueDataPoints = sortAccordingToOrder([
      ...kpi.data_points,
      defaultConfigDataPoints.find(
        (defaultDp: Record<string, any>) =>
          !kpi?.data_points?.some(
            (dp: Record<string, any>) => dp.id === defaultDp.id
          )
      ),
    ]);

    const newKPI = {
      ...kpi,
      data_points: uniqueDataPoints,
    };

    updateUserConfig(kpi.id, newKPI);
    if (uniqueDataPoints.length === defaultConfigDataPoints.length + 1) {
      setShowAll(true);
    }
  };
  const removeDataPoint = (dp_id: string): void => {
    const newDataPoints = kpi.data_points.filter(
      (dp: Record<string, any>) => dp.id !== dp_id
    );
    const newShowAll =
      newDataPoints.length - 1 < defaultConfigDataPoints.length !== true;
    if (newShowAll != showAll) setShowAll(newShowAll);
    const newKPI = {
      ...kpi,
      data_points: newDataPoints,
    };
    updateUserConfig(kpi.id, newKPI);
  };

  const datapointIdToNameMap = getIdToNameMappingOfDataPointsFromKPIID(kpi.id);

  return defaultConfigDataPoints.length > 0 ? (
    <div className="kpi-label-container">
      <div className="kpi-label-title">
        Add labels for data points to be visible on KPI Tile
      </div>
      <div
        className="kpi-label-child"
      >
        {userDataPoints.map((datapoint, index) => {
          return (
            <DataPointInput
              fieldLabel={datapointIdToNameMap[datapoint.id] || "FIELD NAME"}
              kpi={kpi}
              key={index + datapoint.id}
              datapoint={datapoint}
              updateUserConfig={updateUserConfig}
              removeDataPoint={removeDataPoint}
              isRemovableDataPoint={index >= 2}
              inputDataValidation={inputDataValidation}

            />
          );
        })}
           {!showAll && (
        <div className="show-all-button" onClick={handelOnClick}>
          + Add more
        </div>
      )}
     </div>

    </div>
  ) : null;
};

export default KPIConfigDataPointLabelChange;
